import CitizenshipPage from "./CitizenshipPage";

export default CitizenshipPage;
